import { render } from "./EditSubscriber.vue?vue&type=template&id=90dc29dc&scoped=true"
import script from "./EditSubscriber.vue?vue&type=script&lang=js"
export * from "./EditSubscriber.vue?vue&type=script&lang=js"

import "./EditSubscriber.vue?vue&type=style&index=0&id=90dc29dc&scoped=true&lang=css"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90dc29dc"]])

export default __exports__